module.exports = __webpack_public_path__ + "static/media/13.99c0a420.JPG";